export default __webpack_public_path__ + "static/media/payfail.c4343583.svg";